import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomFacade } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-add-ingredients',
  templateUrl: './add-ingredients.component.html',
  styleUrls: ['./add-ingredients.component.scss'],
})
export class AddIngredientsComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  adminIngredientData: any;
  ingredientForm!: FormGroup;
  ingredientAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationList: any;
  ingredientList: any;
  regionList: any;
  selectOrganization: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveNewIngredientEvent = new EventEmitter<any>();

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private administratorService: AdministratorService
  ) {
    this.adminIngredientData =
      this.modal?.modalService?.config?.initialState?.['newIngredientData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isDisabledDropDown = this.modalLabel == 'Review ingredient detail' ? true : false;
    this.ingredientList = this.adminIngredientData.ingredientItem;
    this.regionList = this.adminIngredientData.regionItems;
    const placeHolderOrganization = {
      name: 'All organizations',
    };
    const newOrganizationlist = [placeHolderOrganization].concat(
      this.adminIngredientData.organizationList
    );
    this.organizationList = newOrganizationlist;
    this.indicatorList = this.adminIngredientData.indicatiorList;
    this.organizatioListFunction();
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.adminIngredientData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.ingredientForm = new FormGroup(form);
    this.ingredientAddEditForm = this.formBuilder.group({
      ingredient: [this.adminIngredientData.ingredientId || null, Validators.required],
      region: [null, Validators.required],
      organizationName: [this.adminIngredientData.organizationId || null],
    });
    this.setFormData();
  }

  onChange(value: any) {
    this.ingredientAddEditForm.controls['region'].setValue(null);
    if (!!value?.id) {
      this.administratorService.GetIngredientRegions(value.id).subscribe((data: any) => {
        this.regionData = data.data;
      });
    } else {
      this.regionData = [];
    }
  }

  async organizatioListFunction() {
    await this.organizationList?.map((item: any) => {
      if (item.id == this.adminIngredientData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.adminIngredientData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }
  setFormData() {
    this.ingredientAddEditForm.patchValue({ region: this.selectRegion });
    this.ingredientAddEditForm.patchValue({ organizationName: this.selectOrganization });
  }

  onSave() {
    this.submitted = true;
    if (
      this.ingredientAddEditForm.controls['region'].value?.name == '--Select Region-- ' ||
      (this.activatedRoute == 'admin-ingredient' &&
        !this.ingredientAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (this.ingredientAddEditForm.status == 'VALID' && this.ingredientForm.status == 'VALID') {
      const entires = Object.entries(this.ingredientForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.adminIngredientData.indicatiorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const ingredientPayload = {
        ingredientId: this.ingredientAddEditForm.controls['ingredient'].value,
        regionId:
          this.ingredientAddEditForm.controls['region'].value?.id ||
          this.adminIngredientData.regionId,
        organizationId:
          this.ingredientAddEditForm.controls['organizationName'].value?.name ==
          '--All organization -- '
            ? null
            : this.ingredientAddEditForm.controls['organizationName'].value?.id,
        indicatiorList: resultArray,
      };
      this.saveNewIngredientEvent.emit(ingredientPayload);
      this.onClose();
    }
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
}
